import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { validateLogin } from "../../services/validate-login";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { getFormattedDate } from "../../utils/dateFormat";
import { getSelect3ResponseService } from "../../services/ondcService";
import Loader from "../../components/common/Loader";

function Form() {
  const [loading, setLoading] = useState(true); 
  const [offers, setOffers] = useState<any>(null);
  const [formIsComplete, setFormIsComplete] = useState(false); 

  const navigate = useNavigate();

  useEffect(() => {
    async function getStep() {
      if(Number(localStorage.getItem("step")) >= 6){} else{ navigate("/personal-loan") }
    }
    getStep();
  }, []);

  useEffect(() => {
    async function fetchOffers() {
      try {
        const data = {
          transaction_id: localStorage.getItem("transaction_id"),
          message_id: localStorage.getItem("message_id"),
        };
        const response = await getSelect3ResponseService(data);
        console.log(response)
        if (response.success) {
          setOffers(response?.message?.response);
          console.log(offers)
          setFormIsComplete(true)
        }else{
          setFormIsComplete(false)
          setOffers([]);
        }
      } catch (err) {
        console.error("Error fetching offers:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchOffers();
  }, []);

  // 👉 Show loader full screen while fetching
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader />
      </div>
    );
  }
  const onClickNext = async () => {
    var hl_kyc = "true"
    if(hl_kyc == "true"){
      localStorage.setItem("step", "8")
      navigate("/get-lenders-kyc")
    }
    else{
      localStorage.setItem("step", "7")
      navigate("/get-hl-kyc")
    }
  };

  return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
        {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/img3.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 7
          </div>
        <div className="flex-1 overflow-y-auto">
          <h2 className="text-xl font-semibold mb-6">Review Your Loan Application</h2>
          <p className="text-sm text-gray-600 mb-4"><b>Loan Information</b></p>

          <div className="space-y-6">
            {/* Guard against undefined offers */}
            {Array.isArray(offers) && offers[0]?.tag_list?.map((tag: any, index: number) => (
              <div key={index} className="mb-4">
                <label className="block text-sm text-gray-600 mb-1">
                  {tag.descriptor?.name}
                </label>
                <input
                  readOnly
                  disabled
                  type="text"
                  value={tag.value || ""}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            ))}
          </div>
          <br></br><br></br>
          <p className="text-sm text-gray-600 mb-4"><b>GRO Information</b></p>

          <div className="space-y-6">
            {/* Guard against undefined offers */}
            {offers[0]?.gro_info?.map((tag: any, index: number) => (
              <div key={index} className="mb-4">
                <label className="block text-sm text-gray-600 mb-1">
                  {tag.descriptor?.name}
                </label>
                <input
                  readOnly
                  disabled
                  type="text"
                  value={tag.value || ""}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            ))}
          </div>
        </div>
        

        {/* Buttons */}
        <div className="mt-6 flex gap-4">
          <button
            className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
            onClick={() => navigate("/offer-by-lenders")}
          >
            <ArrowLeft size={18} /> Back
          </button>

          <button
            className={`flex-1 px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${formIsComplete
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-400 cursor-not-allowed"}`}
              disabled={!formIsComplete}
              onClick={onClickNext}
          >
            Next <ArrowRight size={18} />
          </button>
        </div>
      </div>
        </div>
  
        <Footer />
      </div>
  );
}

export default function Step6OfferDetails() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      <main className="flex-1 overflow-y-auto">
        <Form />
      </main>
    </div>
  );
}
